import { render } from "./VehicleDefectCodes.vue?vue&type=template&id=1b03246c"
import script from "./VehicleDefectCodes.vue?vue&type=script&lang=ts"
export * from "./VehicleDefectCodes.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QCheckbox});
